import { BigDecimalService } from './big-decimal/big-decimal.service';

export function format(first: string, middle: string, last: string): string {
  return (
    (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '')
  );
}

export function createMoIframe(
  clientId: string,
  price: string
): HTMLMoOfferFrameElement {
  const body = document.getElementsByTagName('body')[0];
  const element = document.createElement('mo-offer-frame');

  element.id = 'mo-offer-frame';
  element.setAttribute('client-id', clientId);
  element.setAttribute('price', price);
  return body.insertBefore(element, body[0]);
}

export function removeMoIframe(): void {
  let offerFrame = document.getElementById('mo-offer-frame');
  return offerFrame?.remove();
}

export function validMoClientId(id: string): boolean {
  const idLength: number = id?.length;
  return idLength > 10 && typeof id === 'string' ? true : false;
}

export function validProductPrice(price: string): boolean {
  const validNumber = !!Number(price);
  return validNumber;
}

export function setInstallmentsByPrice(price: string): string {
  if (!validProductPrice(price)) return;

  const installment: string = divBigDecimal(price, '3');
  const test: string = installment.slice(0, installment.indexOf('.') + 3);
  const formatNumber: string = (
    Math.trunc(Number(test) * Math.pow(10, 2)) / Math.pow(10, 2)
  ).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `S/${formatNumber}`;
}

export function convertToBase64(value: string): string {
  return window.btoa(value);
}

export function divBigDecimal(value1: string, value2: string): string {
  const n1 = new BigDecimalService(value1);
  const n2 = new BigDecimalService(value2);
  const n3 = n1.divide(n2, 8);
  return n3.getValue(); // quotient
}

export function sendEvent(
  category: string,
  action: string,
  label: string = null,
  value: number = null
) {
  label = `${category}_${action}`;
  if (typeof window['dataLayer'] !== 'undefined') {
    window['dataLayer'].push({
      event: `${action}_${category}`,
      eventCategory: category,
    });
  }
}
